let elements = {
  blockCheck: true,
  blockWrongColor: true,
  audio: {
    negative: 'games/page009_game0/audio/false.mp3',
    // positive: 'games/page009_game0/audio/true.mp3',
    click: 'games/page009_game0/audio/click.mp3',
  },
  image: {
    trImage: 'games/page009_game0/img/img_t.webp',
    srcImage: 'games/page009_game0/img/img_o.png',
    srcMask: 'games/page009_game0/img/img_m.png',
    width: 1920,
    height: 1080,
    colors: {
      1: '#000000',
      2: '#f2ea00',
      3: '#ff69c0',
      4: '#53bb3f',
      5: '#ea742f',
      6: '#05a6e2',
    },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      {
        audioId: 'a1',
        val: '#53bb3f',
        audio: 'games/page009_game0/audio/11_green.mp3',
        waitingToBeClicked: { src: 'games/page009_game0/img/green.png' },
        clicked: { src: 'games/page009_game0/img/green_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '73.4%',
          top: '27.8%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        audioId: 'a2',
        val: '#f2ea00',
        audio: 'games/page009_game0/audio/10_yellow.mp3',
        waitingToBeClicked: { src: 'games/page009_game0/img/yellow.png' },
        clicked: { src: 'games/page009_game0/img/yellow_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '64.8%',
          top: '34.4%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(242,234,0,0.4)',
        },
      },
      // {
      //   audioId: 'a8',
      //   val: '#fffefe',
      //   waitingToBeClicked: { src: 'games/page009_game0/img/white.png' },
      //   clicked: { src: 'games/page009_game0/img/white_p.png' },
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '71.45%',
      //     top: '42%',
      //     width: '8.2%',
      //     height: '14.6%',
      //     transform: 'rotate(0deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(223,0,36,0.4)',
      //   },
      // },
      {
        audioId: 'a3',
        val: '#ea742f',
        audio: 'games/page009_game0/audio/14_orange.mp3',
        waitingToBeClicked: { src: 'games/page009_game0/img/orange.png' },
        clicked: { src: 'games/page009_game0/img/orange_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '75%',
          top: '42%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(234,116,47,0.4)',
        },
      },
      {
        audioId: 'a4',
        val: '#df0024',
        waitingToBeClicked: { src: 'games/page009_game0/img/red.png' },
        clicked: { src: 'games/page009_game0/img/red_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '85.3%',
          top: '42.8%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(223,0,36,0.4)',
        },
      },
      {
        audioId: 'a5',
        val: '#b604db',
        waitingToBeClicked: { src: 'games/page009_game0/img/purple.png' },
        clicked: { src: 'games/page009_game0/img/purple_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '62.4%',
          top: '48.6%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(182,4,219,0.4)',
        },
      },
      {
        audioId: 'a6',
        val: '#05a6e2',
        audio: 'games/page009_game0/audio/8_blue.mp3',
        waitingToBeClicked: { src: 'games/page009_game0/img/blue.png' },
        clicked: { src: 'games/page009_game0/img/blue_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '70.7%',
          top: '55%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(5,166,226,0.4)',
        },
      },
      {
        audioId: 'a7',
        val: '#ff69c0',
        audio: 'games/page009_game0/audio/13_pink.mp3',
        waitingToBeClicked: { src: 'games/page009_game0/img/pink.png' },
        clicked: { src: 'games/page009_game0/img/pink_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '79.8%',
          top: '55.6%',
          width: '8.2%',
          height: '14.6%',
          transform: 'rotate(0deg)',
          'border-radius': '50%',
          // 'background-color': 'rgba(255,105,192,0.4)',
        },
      },
    ],
    mbPaletteAudioItemData: [
      {
        id: 'a1',
        src: 'games/page009_game0/audio/11_green.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      {
        id: 'a2',
        src: 'games/page009_game0/audio/10_yellow.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      // {
      //   id: 'a8',
      //   src: 'games/page009_game0/audio/white.mp3',
      //   audioConfig: {
      //     autoplay: false,
      //     loop: false,
      //     volume: 1,
      //   },
      //   iconConfig: {
      //     src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
      //     fill: 'none',
      //   },
      //   width: '46px',
      //   height: '46px',
      //   pos: {
      //     y: 10,
      //     x: -10,
      //   },
      //   unit: 'px',
      // },
      {
        id: 'a3',
        src: 'games/page009_game0/audio/14_orange.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      {
        id: 'a4',
        src: 'games/page009_game0/audio/8_red.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      {
        id: 'a5',
        src: 'games/page009_game0/audio/12_purple.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      {
        id: 'a6',
        src: 'games/page009_game0/audio/8_blue.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
      {
        id: 'a7',
        src: 'games/page009_game0/audio/13_pink.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 10,
          x: -10,
        },
        unit: 'px',
      },
    ],
  },
  mbStaticAudioItemData: [
    {
      src: 'games/page009_game0/audio/10_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        y: 385,
        x: 82,
      },
      unit: 'px',
    },
    {
      src: 'games/page009_game0/audio/13_pink.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        y: 615,
        x: 325,
      },
      unit: 'px',
    },
    {
      src: 'games/page009_game0/audio/11_green.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        y: 774,
        x: 410,
      },
      unit: 'px',
    },
    {
      src: 'games/page009_game0/audio/8_blue.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        y: 910,
        x: 90,
      },
      unit: 'px',
    },
    {
      src: 'games/page009_game0/audio/14_orange.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page009_game0/img/audioOn.png', iconOff: 'games/page009_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        y: 884,
        x: 387,
      },
      unit: 'px',
    },
  ],
};

export default elements;
